import React from 'react'
import notificationActions from 'redux/models/notifications/actions'
import { useEffect, useMedia, useCallback } from 'sb-hooks'

import MobileView from './MobileView/MobileView'
import DefaultView from './DefaultView/DefaultView'


const Notification: React.FunctionComponent<Notifications.Item> = (props) => {
  const { id, text, title, svgName } = props

  const { isMobile } = useMedia()

  const handleHide = useCallback(() => {
    notificationActions.removeNotification(id)
  }, [ id ])

  useEffect(() => {
    setTimeout(handleHide, 3000)
  }, [ handleHide ])

  if (isMobile) {
    return (
      <MobileView
        text={text}
        onHide={handleHide}
      />
    )
  }

  // if you need new view, create component

  return (
    <DefaultView
      svgName={svgName}
      title={title}
      text={text}
      onHide={handleHide}
    />
  )
}


export default React.memo(Notification)
